// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"343a03f5","674":"a46c4b51"}[chunkId] + ".chunk.js";
};